<template lang="pug">
  Default
    .content__header.is-404
      button.content__menu-open(
        type='button'
        @click='showSidebar'
      )
      h1.content__title {{ $l10n("ERROR_WHEN_PAGE_LOADING") }}
      p.content__caption {{ $l10n("ERROR_WHEN_PAGE_LOADING_CAPTION") }}
    .content__body
      img(
        src='/img/404-page.gif'
        style='mix-blend-mode: multiply; margin: auto; max-height: 400px'
      )
</template>

<script>
import showSidebar from "@/mixins/shared/showSidebar.mixin";
import Default from "@/layouts/Default";

export default {
  mixins: [showSidebar],
  components: {
    Default
  }
};
</script>
